export enum AttachmentType {
    INPUT_FILE = 1,
    OUTPUT_FILE = 2,
    ZC_INDEXED_PR_FOLIOS = 1000,
    ZC_VERSION_FAILED_PR_FOLIOS = 2000,
    ZC_VERSION_PROPERTIES_WITH_NOTIFICATIONS = 3000
}

export function getPrettyAttachmentType(value: number): string {
    return {
        0: '', 1: 'Input parameters', 2: 'Result', 1000: 'Index property records', 2000: 'Failed property records',
        3000: 'Properties with notifications'
    }[value];
}
